// @owners { team: patients }
import { Link } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useEffect } from 'react';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export type Props = {
  readonly handleModalClose: () => void;
  readonly prescriptionId: number;
};

const label = 'Learn more';

export const OrderEarlyLearnMoreLink = ({ handleModalClose, prescriptionId }: Props) => {
  const { navigate } = useNavigation();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent({
      event: EVENTS.PROGYNY_FERTILITY_CYCLE_FORM_PROMPT_VIEWED,
      params: { prescriptionId, prompt: label },
    });
  }, [trackEvent, prescriptionId]);

  return (
    <Link
      onPress={() => {
        handleModalClose();
        navigate('RouteOrderEarlyForm', { prescriptionId });
        trackEvent({
          event: EVENTS.PROGYNY_FERTILITY_CYCLE_FORM_PROMPT_PRESSED,
          params: { prescriptionId, prompt: label },
        });
      }}
    >
      {label}
    </Link>
  );
};
